import { useTranslation } from '../../i18n/LanguageProvider';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="site-footer">
      <div className='container'>
        <small>
          <>
            {process.env.REACT_APP_COMMIT_DATE && (
              <span>{t('footer.lastUpdated')} {process.env.REACT_APP_COMMIT_DATE}<br /></span>
            )}
            &copy; {new Date().getFullYear()} Frederico Schardong
          </>
        </small>
      </div>
    </footer>
  );
}
